import { BaseFrontdoorAdapter } from "../frontdoor/BaseFrontdoorAdapter";

/**
 * FrontdoorUserSettingsAdapter
 * Manages user settings via Frontdoor REST API.
 */
export class FrontdoorUserSettingsAdapter extends BaseFrontdoorAdapter {
  /**
   * Get all user settings.
   * GET /api/user-settings
   */
  async getAllUserSettings() {
    return this.get("/api/user-settings");
  }

  /**
   * Get user settings for a user.
   * GET /api/user-settings/user/{userId}
   * @param {string} userId - User UUID
   */
  async getUserSettings(userId) {
    return this.get(`/api/user-settings/user/${userId}`);
  }

  /**
   * Get a specific user setting by key.
   * GET /api/user-settings/user/{userId}/key/{key}
   * @param {string} userId - User UUID
   * @param {string} key - Setting key
   */
  async getUserSettingByKey(userId, key) {
    return this.get(`/api/user-settings/user/${userId}/key/${key}`);
  }

  /**
   * Create or update user settings.
   * POST /api/user-settings
   * @param {string} userId - User UUID
   * @param {string} key - Setting key
   * @param {*} value - Setting value (serialized to JSON if not a string)
   * @param {number} [clientType=1] - Client type identifier
   */
  async saveUserSettings(userId, key, value, clientType = 1) {
    const payload = {
      userId,
      key,
      value: typeof value === "string" ? value : JSON.stringify(value),
      clientType,
    };
    return this.post("/api/user-settings", payload);
  }

  /**
   * Delete a user setting by key.
   * DELETE /api/user-settings/user/{userId}/key/{key}
   * @param {string} userId - User UUID
   * @param {string} key - Setting key
   */
  async deleteUserSettings(userId, key) {
    return this.delete(`/api/user-settings/user/${userId}/key/${key}`);
  }
}
